export { default } from './FixedBottom';
export * from './FixedBottom';
